export const getCurrentDomain = (): string => {
  const hostname = window.location.hostname;
  // Remove www. prefix if present
  return hostname.replace(/^www\./, "");
};
